import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import { FETCH_SCHEDULE_SHIFTS, FETCH_SCHEDULE_SHIFT } from './types';

const showScheduleShiftError = (error) => {
    NotificationManager.error(error.response?.data?.msg || 'Không thể xử lý lịch phân ca.');
};

export const fetchScheduleShifts = (filters = {}) => dispatch => api
    .get('/schedule-shifts', { params: filters })
    .then(res => {
        dispatch({ type: FETCH_SCHEDULE_SHIFTS, payload: res.data.data });
        return res.data;
    })
    .catch(error => {
        showScheduleShiftError(error);
        return Promise.reject(error);
    });

export const fetchScheduleShift = id => dispatch => api
    .get(`/schedule-shifts/${id}`)
    .then(res => {
        dispatch({ type: FETCH_SCHEDULE_SHIFT, payload: res.data.data });
        return res.data.data;
    })
    .catch(error => {
        showScheduleShiftError(error);
        return Promise.reject(error);
    });

export const createScheduleShifts = data => () => api
    .post('/schedule-shifts', data)
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data.data;
    })
    .catch(error => {
        showScheduleShiftError(error);
        return Promise.reject(error);
    });

export const updateScheduleShift = (id, data) => () => api
    .put(`/schedule-shifts/${id}`, data)
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data.data;
    })
    .catch(error => {
        showScheduleShiftError(error);
        return Promise.reject(error);
    });

export const removeScheduleShifts = ids => () => api
    .delete('/schedule-shifts', { data: { ids } })
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data;
    })
    .catch(error => {
        showScheduleShiftError(error);
        return Promise.reject(error);
    });
